import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import ax from "./auth/axios";
import { API_ROOT } from "./utils/api-config";
import { connect } from "react-redux";
import { editUserProfile } from "../actions/userAction";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Navbar from "react-bootstrap/Navbar";

class EditUserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      admin: false,
      merchant_id: "",
      inputted_store: "",
      accepted_terms: false,
      driver: false,
      driver_id: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { uzer } = this.props;
    this.setState({
      first_name: uzer.first_name,
      last_name: uzer.last_name,
      email: uzer.email,
      admin: uzer.admin ? uzer.admin : false,
      merchant_id: uzer.merchant_id,
      inputted_store: uzer.inputted_store,
      accepted_terms: uzer.accepted_terms ? uzer.accepted_terms : false,
      driver: uzer.driver ? uzer.driver : false,
      driver_id: uzer.driver_id ? uzer.driver_id : null,
    });
  }
  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    formData.append("user[first_name]", this.state.first_name);
    formData.append("user[last_name]", this.state.last_name);
    formData.append("user[email]", this.state.email);
    formData.append("user[admin]", this.state.admin);
    formData.append("user[driver]", this.state.driver);
    this.state.driver &&
      formData.append("user[driver_id]", this.state.driver_id);
    formData.append("user[merchant_id]", this.state.merchant_id);
    formData.append("user[inputted_store]", this.state.inputted_store);
    formData.append("user[accepted_terms]", this.state.accepted_terms);
    ax.patch(
      `${API_ROOT}/users/${this.props.match.params.id}`,
      formData,
      config
    ).then((response) => {
      this.props.editUserProfile(response.data);
    });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  render() {
    return (
      <div className="container-fluid">
        <Navbar className="bg-info justify-content-between">
          <Navbar.Brand>
            Edit User Profile of {this.state.first_name} {this.state.last_name}
          </Navbar.Brand>
        </Navbar>
        <Form onSubmit={this.handleSubmit}>
          <br></br>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                name="first_name"
                value={this.state.first_name}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                name="last_name"
                onChange={this.handleInputChange}
                value={this.state.last_name}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                onChange={this.handleInputChange}
                value={this.state.email ? this.state.email : ""}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridStore">
              <Form.Label>Inputted Store</Form.Label>
              <Form.Control
                name="inputted_store"
                onChange={this.handleInputChange}
                value={
                  this.state.inputted_store ? this.state.inputted_store : ""
                }
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Accepted Terms</Form.Label>
              <Form.Check
                name="accepted_terms"
                onChange={this.handleInputChange}
                checked={this.state.accepted_terms}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formGridMerchantId">
              <Form.Label>Merchant ID</Form.Label>
              <Form.Control
                name="merchant_id"
                onChange={this.handleInputChange}
                value={this.state.merchant_id ? this.state.merchant_id : ""}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>Admin</Form.Label>
              <Form.Check
                name="admin"
                onChange={this.handleInputChange}
                checked={this.state.admin}
              />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>Driver</Form.Label>
              <Form.Check
                name="driver"
                onChange={this.handleInputChange}
                checked={this.state.driver}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridDriverID">
              <Form.Label>Driver ID</Form.Label>
              <Form.Control
                name="driver_id"
                onChange={this.handleInputChange}
                value={this.state.driver_id ? this.state.driver_id : ""}
              />
            </Form.Group>
          </Form.Row>
          <Button type="submit" variant="outline-danger">
            Save Changes
          </Button>
        </Form>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  editUserProfile: (uzer) => dispatch(editUserProfile(uzer)),
});
export default withRouter(connect(null, mapDispatchToProps)(EditUserProfile));
